import { Expose } from 'class-transformer';

export class ServiceTypeDto {
  @Expose()
  uuid: string;

  @Expose()
  title: string;

  @Expose()
  description: string;
}
